import * as React from "react";
// UI Frameworks
import { Dropdown as AntdDropdown } from "antd";
import { DropDownProps } from "antd/lib/dropdown";

interface IProps extends DropDownProps {
	children?: React.ReactNode;
}
const Dropdown: React.FC<IProps> = props => {
	return <AntdDropdown {...props} />;
};

export default Dropdown;
